import FeaturePage from "../../components/FeaturePage";
import { Database, Shield, Cpu, Globe2, Users, Headphones } from "lucide-react";

export default function Large() {
  return (
    <FeaturePage
      badge="For Large Businesses"
      title="Run a complex operation."
      highlight="Simply."
      subtitle="Hundreds of SKUs, dozens of locations, complex approval flows. Brivo handles it with deep analytics, custom roles, and integrations to your existing stack."
      heroImage="https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="mint"
      features={[
        { icon: <Database size={22} />, title: "Bulk operations", desc: "Import 100k SKUs, mass-edit pricing, bulk export — all without breaking a sweat." },
        { icon: <Shield size={22} />, title: "Advanced security", desc: "SSO, 2FA, IP allowlists, audit logs, custom data retention policies." },
        { icon: <Cpu size={22} />, title: "Open API", desc: "REST & GraphQL APIs, webhooks, and a robust SDK for custom builds." },
        { icon: <Globe2 size={22} />, title: "Global commerce", desc: "Multi-currency, multi-tax-jurisdiction, multi-language out of the box." },
        { icon: <Users size={22} />, title: "Custom roles", desc: "Build precise permission models for your unique org structure." },
        { icon: <Headphones size={22} />, title: "Dedicated CSM", desc: "Named customer success manager with quarterly business reviews." },
      ]}
      details={[
        {
          tag: "Performance",
          title: "Engineered for high throughput.",
          desc: "Brivo handles 10,000+ orders per day per account, with 99.99% uptime, sub-100ms API response times, and global edge caching.",
          bullets: ["99.99% uptime SLA", "Edge caching across 6 regions", "10K+ orders/day capacity"],
        },
        {
          tag: "Integrations",
          title: "Plug into your existing stack.",
          desc: "Out-of-the-box integrations with NetSuite, SAP, Salesforce, and HubSpot. Plus open APIs for your team to build anything.",
        },
      ]}
      useCases={[
        { title: "National retailers", desc: "100+ stores with HQ rollups." },
        { title: "Multi-brand groups", desc: "Run multiple banners under one account." },
        { title: "Regional distributors", desc: "Wholesale across territories." },
        { title: "Manufacturers", desc: "BOMs, raw materials, finished goods, B2B portal." },
      ]}
      ctaTitle="Enterprise-grade. Without enterprise pain."
      ctaSubtitle="Brivo delivers the depth you need with the simplicity you've been missing."
      ctaAccent="cream"
    />
  );
}
